import React, { useState } from 'react'
import {FileTextOutlined} from '@ant-design/icons';
import { Modal, Space } from 'antd';
import DocDesc from './DocDesc';
function DocCheck(props) {
    const [open,setOpen] = useState(false)

    return (
        <>
            <a onClick={() => {setOpen(true)}}>
                <Space><FileTextOutlined/>{props.bmjwd_name}</Space>
            </a>
            <Modal
                open={open}
                okText="提交"
                cancelText="取消"
                onCancel={() => {
                    setOpen(false);
                }}
                onOk={() => {}}
                footer={null}
                width={1200}
            >            
                <DocDesc
                    bmjwd_id={props.bmjwd_id}
                    bmj_name={props.bmj_name}    
                    bmj_id={props.bmj_id}    
                />            
            </Modal>
        </>
    )
}

export default DocCheck